import { render, staticRenderFns } from "./FreshdeskWidget.vue?vue&type=template&id=1ae47f99&"
import script from "./FreshdeskWidget.vue?vue&type=script&lang=ts&"
export * from "./FreshdeskWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src736765657/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae47f99')) {
      api.createRecord('1ae47f99', component.options)
    } else {
      api.reload('1ae47f99', component.options)
    }
    module.hot.accept("./FreshdeskWidget.vue?vue&type=template&id=1ae47f99&", function () {
      api.rerender('1ae47f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/FreshdeskWidget.vue"
export default component.exports